import feature1 from './../assets/solutions/1/01-Comprehensive.webp'
import feature2 from './../assets/solutions/1/02-Attack-paths.webp'
import feature3 from './../assets/solutions/1/03-Lifecycle.webp'
import feature4 from './../assets/solutions/1/04-GenAI.webp'
import b_feature1 from './../assets/solutions/2/01-Attack-paths.webp'
import b_feature2 from './../assets/solutions/2/02-Cloud-Compliance.webp'
import b_feature3 from './../assets/solutions/2/03-AI-remediation.webp'
import b_feature4 from './../assets/solutions/2/04-AI-search.webp'
import c_feature1 from './../assets/solutions/3/01-Cloud-native.webp'
import c_feature2 from './../assets/solutions/3/02-CWPP-coverage.webp'
import c_feature3 from './../assets/solutions/3/03-Malware.webp'
import c_feature4 from './../assets/solutions/3/orca-sensor-platform-image-4.webp'
import d_feature1 from './../assets/solutions/4/01-Compliance.webp'
import d_feature2 from './../assets/solutions/4/02-Queries.webp'
import d_feature3 from './../assets/solutions/4/03-Insecure-keys.webp'
import d_feature4 from './../assets/solutions/4/04-Reduce-IAM-risks.webp'
import d_feature5 from './../assets/solutions/4/05-Cloud-attacks.webp'
import d_feature6 from './../assets/solutions/4/06-Attack-paths.webp'
import e_feature1 from './../assets/solutions/5/01-Discover.webp'
import e_feature2 from './../assets/solutions/5/02-Attack-surface.webp'
import e_feature3 from './../assets/solutions/5/03-Compliance-1.webp'
import e_feature4 from './../assets/solutions/5/04-Data-activity.webp'
import f_feature1 from './../assets/solutions/6/01-Agentless.webp'
import f_feature2 from './../assets/solutions/6/02-Vulnerability-management.webp'
import f_feature3 from './../assets/solutions/6/03-Compliance.webp'
import f_feature4 from './../assets/solutions/6/04-CDR.webp'
import g_feature1 from './../assets/solutions/7/01-Custom-frameworks.webp'
import g_feature2 from './../assets/solutions/7/02-Sensitive-data.webp'
import g_feature3 from './../assets/solutions/7/03-Remediation.webp'
import g_feature4 from './../assets/solutions/7/04-Releases.webp'
import g_feature5 from './../assets/solutions/7/05-Reporting.webp'
import h_feature1 from './../assets/solutions/8/01-Cloud-native-vulnerability-management.webp'
import h_feature2 from './../assets/solutions/8/02-Interconnected.webp'
import h_feature3 from './../assets/solutions/8/03-Understand-a-CVE.webp'
import i_feature1 from './../assets/solutions/9/01-Inventory.webp'
import i_feature2 from './../assets/solutions/9/02-Prioritization.webp'
import i_feature3 from './../assets/solutions/9/03-Changelog.webp'
import j_feature1 from './../assets/solutions/10/01-Continuous-analysis.webp'
import j_feature2 from './../assets/solutions/10/orca-cdr-dashboard-screenshot.webp'
import j_feature3 from './../assets/solutions/10/03-AI-remediation-1.webp'
import j_feature4 from './../assets/solutions/10/04-Frictionless-workflow-integration.webp'
import j_feature5 from './../assets/solutions/10/03-AI-remediation-1.webp'
import k_feature1 from './../assets/solutions/11/shift-left-image-1.webp'
import k_feature2 from './../assets/solutions/11/shift-left-image-2.webp'
import k_feature3 from './../assets/solutions/11/shift-left-image-3.webp'
import k_feature4 from './../assets/solutions/11/shift-left-image-4.webp'
import k_feature5 from './../assets/solutions/11/orca-security-console-with-circle.webp'
import k_feature6 from './../assets/solutions/11/shift-left-image-github.webp'
import l_feature1 from './../assets/solutions/12/ai-security-inventory.webp'
import l_feature2 from './../assets/solutions/12/ai-security-compliance-score.webp'
import l_feature3 from './../assets/solutions/12/ai-security-asset-view.webp'
import l_feature4 from './../assets/solutions/12/ai-security-access-key.webp'
import m_feature1 from './../assets/solutions/13/Amazon-Bedrock-Orca.webp'
import m_feature2 from './../assets/solutions/13/Orca-AI-Search-300.webp'
import m_feature3 from './../assets/solutions/13/03-IAM-policy-management.webp'
import m_feature4 from './../assets/solutions/13/Orca-AI-Description-Asset-300.webp'
import m_feature5 from './../assets/solutions/13/CDR-AI-Anomaly-Detection.webp'
import n_feature1 from './../assets/solutions/14/mri-cloud-state.webp'
import n_feature2 from './../assets/solutions/14/workload-telemetry.webp'

const solution_data = [
  {
    url: 'cloud-native-application-protection-platform',
    title: 'Cloud Native Application Protection Platform (CNAPP)',
    desc: 'The true CNAPP that secures all your cloud assets, data, cloud native applications, APIs, and more from a single platform',
    challenge: 'Siloed Point Solutions and Poorly Integrated CNAPPs',
    challenge_desc: 'Security teams waste valuable time deploying and administering disparate point solutions and correlating high-volume, low-risk alert data from multiple or disjointed security tools. This leads to inefficiency and, even more importantly, the inability to see the big picture, which is essential to identifying attack paths and understanding which risks are the most critical and need to be fixed first.',
    partner_info: [
      {
        title: "Simplified Alert Management",
        description: "Critical alerts are being missed because of alert fatigue caused by having too many point solutions.",
      },
      {
        title: "Unified Security Platform",
        description: "Several ‘CNAPP’ solutions have been stitched together by acquiring different tools, lacking the unified insights of a true CNAPP.",
      },
      {
        title: "Code-to-Production Insights",
        description: "Many CNAPP tools only offer limited shift left capabilities and completely miss tying issues in production back to code origin.",
      },
    ],
    features: [
      {
        image: feature1,
        title: 'The Comprehensive CNAPP with 100% coverage',
        description: `
          <p class="text-justify">Siberwander Orca's patented SideScanning™ technology allows you to deploy comprehensive cloud native security in minutes without requiring agents – providing 100% continuous coverage and automatically including any newly added assets.</p>
          <br/>
          <ul class="text-justify">
            <li>Replace many disparate point solutions with a purpose-built CNAPP that combines workload-deep intelligence with cloud configuration metadata in a truly unified data model.</li>
            <li>Surface all cloud risks, including vulnerabilities, malware, misconfigurations, lateral movement risks, IAM risks, API risks, sensitive data at risk, and suspicious activities.</li>
            <li>Streamline cloud security and compliance across all your cloud platforms from a single CNAPP, ensuring policies are aligned and avoiding duplicate efforts.</li>
          </ul>
        `
      },
      {
        image: feature2,
        title: 'Strategic remediation with attack path analysis to understand risks',
        description: `
          <p class="text-justify">With multi-cloud attack path analysis, Siberwander Orca helps security teams work smarter and utilize their resources in the most effective way. Instead of trying to fix all risks, Siberwander Orca shows teams how to remediate strategically by highlighting which cloud security risks:</p>
          <br/>
          <ul class="text-justify">
            <li>Endanger their most critical business assets</li>
            <li>Are part of the most attack paths with the highest severity</li>
            <li>Affect the most cloud assets</li>
            <li>Are exposed by the most cloud assets</li>
          </ul>
          <p class="text-justify">Armed with this intelligence, security teams instantly know where their time is best spent, relieving alert overload and burnout, as well as dramatically improving security outcomes.</p>
        `
      },
      {
        image: feature3,
        title: 'Security across the full application lifecycle–and back again',
        description: `
          <p class="text-justify">Siberwander Orca’s CNAPP secures cloud native applications in development by identifying vulnerabilities and misconfigurations as code is built before it’s deployed to production and helps security teams coordinate remediation with development and DevOps.</p>
          <br/>
          <ul class="text-justify">
            <li>Siberwander Orca enables organizations to apply security policies early in development to avoid issues making it to production.</li>
            <li>Automatically run compliance and security checks as part of the CI/CD process, including IaC template and container image scanning.</li>
            <li>Siberwander Orca traces findings from the production environment to their code origins, greatly accelerating the remediation of risks in cloud native applications.</li>
          </ul>
        `
      },
      {
        image: feature4,
        title: 'Augmented Cloud Security with Generative AI',
        description: `
          <p class="text-justify">The Siberwander Orca CNAPP Platform widely leverages AI to enhance the detection of risks, simplify investigations, and speed up remediation – saving cloud security, DevOps, and development teams time and effort while significantly improving security outcomes:</p>
          <br/>
          <ul class="text-justify">
            <li>Accelerate cloud security remediation by applying AI-generated code for IaC and CLI or following steps in the console.</li>
            <li>With cloud asset search that is as intuitive as asking a question, teams across the organization are empowered to make data-driven decisions.</li>
            <li>Quickly apply identity policies to effortlessly right-size permissions and entitlements.</li>
          </ul>
        `
      }
    ],
    faqs: [
      {
        question: "What is CNAPP?",
        answer: `
          <span>A Cloud-Native Application Protection Platform (CNAPP) is a cloud security solution that provides comprehensive coverage and visibility into multi-cloud environments, while also detecting risks across the full technology stack. This includes cloud misconfigurations, mismanaged identity access, vulnerabilities, and insecure workloads. </span>
          <br />
          <br />
          <span>First named as a cloud security category by Gartner in 2020, CNAPPs have emerged as an alternative solution to many traditional cloud security tools, integrating their disparate capabilities into one platform. This includes Cloud Workload Protection Platform (CWPP), Cloud Security Posture Management (CSPM), Cloud Infrastructure Entitlements Management (CIEM), and other solutions such as compliance tools, API Security and Data Security Posture Management (DSPM).</span> 
        `
      },
      {
        question: "Why is CNAPP important?",
        answer: `
          <div>
            CNAPPs have emerged to address the challenges of using siloed traditional cloud security solutions. CNAPPs offer a number of benefits, including:
            <ul style={{ paddingLeft: '3%' }}>
              <li><strong>Improved cloud risk management:</strong> CNAPP solutions centralize cloud security insights, fully contextualize and prioritize risks, detect new issues and threats, and provide reporting, analytics, and remediation guidance.</li>
              <li><strong>Comprehensive cloud visibility:</strong> Agentless-first CNAPPs provide complete visibility across cloud infrastructure and workloads, including containers and serverless functions.</li>
              <li><strong>Lower TCO and licensing costs:</strong> By consolidating standalone tools, many CNAPPs allow organizations to reduce their cloud security spend.</li>
              <li><strong>Enhanced compliance:</strong> CNAPPs ease compliance efforts, lower costs, and improve adherence.</li>
              <li><strong>Support for DevSecOps:</strong> Some CNAPPs offer “Shift Left” security capabilities that detect vulnerabilities, misconfigurations, secrets, and malware early in the software development lifecycle (SDLC), making it possible to fix problems before being pushed into production. This reduces development costs, accelerates production, and eases friction between security and development teams.</li>
            </ul>
          </div>
        `
      },
      {
          question: "How does CNAPP work?",
          answer: `
            <div>
              CNAPPs manage risks and compliance issues across an organization’s entire cloud estate, including multi-cloud environments. CNAPPs perform the following activities to provide complete visibility, coverage, and protection:
              <ul style={{ paddingLeft: '3%' }}>
                <li><strong>Provide a full inventory of cloud assets:</strong> Track and present a detailed inventory of cloud assets and applications.</li>
                <li><strong>Detect cloud risks and generate alerts:</strong> Identify all risks and compliance issues in the cloud environment,create alerts, and prioritize issues for remediation.</li>
                <li><strong>Continuously monitor:</strong> Continuously monitor the cloud environment to discover new assets, issues, and risks.</li>
                <li><strong>Integrate with productivity and security tools: </strong> Communicate with common security and productivity tools (e.g., SIEM, ticketing systems, developer tools, etc.) to streamline and enhance workflows.</li>
                <li><strong>Reporting:</strong> Generate reports to assist with compliance efforts, internal and external communications, and other purposes.</li>
              </ul>
            </div>
          `
      },
      {
        question: "How does CNAPP compare to other cloud security solutions?",
        answer: 'CNAPP actually combines the capabilities of CSPM (detect misconfigurations and compliance), CWPP (detect vulnerabilities, malware, and exposed secrets in cloud-based workloads across virtual machines (VMs), containers, and serverless functions), CIEM (manage access rights and permissions for your cloud resources), Data Security Posture Management (DSPM), Kubernetes and container security, API security, and more.',
      },
      {
        question: "What are the advantages of Siberwander vs. other CNAPP solutions?",
        answer: `
          <span>Siberwander Orca Cloud Security Platform was built from the ground up as a truly unified cloud native platform: a single platform that provides 100% coverage, detects risks at every layer of your cloud estate, and sees the bigger picture to effectively identify the most critical risks that security teams should focus on.</span>
          <br />
          <br />
          <span>Because Siberwander Orca is agentless-first, the platform deploys in minutes with no downtime and without impacting workload performance or DevOps workflows—while maintaining full visibility as your cloud estate evolves. In addition to containers, serverless, and cloud infrastructure, Siberwander Orca discovers and monitors idle, paused, and stopped workloads, orphaned systems, and devices that can’t support agents.</span>
        `
      },
    ]
  },
  {
    url: 'cloud-security-posture-management',
    title: 'Cloud Security Posture Management (CSPM)',
    desc: 'Continuously monitor for cloud misconfigurations, policy violations, and compliance risks',
    challenge: 'Traditional CSPM Isn’t Enough',
    challenge_desc: 'Traditional CSPM solutions help organizations stay compliant and address cloud risks such as misconfigurations and overly permissive identities. However, a CSPM only covers one part of the attack surface, leaving cloud workloads, event monitoring, and sensitive data discovery out of the picture.',
    partner_info: [
      {
        title: "Complete Cloud Visibility",
        description: "Traditional CSPMs lack insight into cloud workloads, which means they cannot detect vulnerabilities, malware, data at risk, or exposed secrets.",
      },
      {
        title: "Eliminate Security Gaps",
        description: "Security teams must supplement traditional CSPMs with multiple siloed tools, which results in constantly having to switch consoles, duplicating efforts, and hindering consistency.",
      },
      {
        title: "Unified Alerting and Prioritization",
        description: "Siloed or ‘integrated’ tools lack shared context, resulting in contradictory alerts and ineffective alert prioritization.",
      },
    ],
    features: [
      {
        image: b_feature1,
        title: "Understand risks across your entire tech stack",
        description: `
          <p class="text-justify">Unlike other CSPMs, Siberwander Orca also scans cloud workloads and identities to surface full insights into the risks across your entire tech stack. This enables Siberwander Orca to understand which risk combinations pose the greatest danger, so your teams can address those first.</p>
          <ul class="text-justify">
            <li>By scoring and prioritizing attack paths, security teams can focus on a much smaller number of dangerous attack paths versus sifting through hundreds of siloed alerts.</li>
            <li>Siberwander Orca presents potential attack paths in a visual graph showing the end target as well as detailed information on each step.</li>
            <li>For each attack path, Siberwander Orca shows which risks need to be remediated to break the attack path, further prioritizing issues for remediation if they break multiple paths.</li>
          </ul>
        `,
      },
      {
        image: b_feature2,
        title: "Ensure multi-cloud compliance",
        description: `
          <p class="text-justify">Another important CSPM function that Siberwander Orca provides is ensuring that cloud resources comply with regulatory frameworks and industry benchmarks, including data privacy requirements. Siberwander Orca unifies compliance for cloud infrastructure workloads, containers, identities, data and more – all in a single dashboard.</p>
          <ul class="text-justify">
            <li>Siberwander Orca checks cloud configurations and policies against more than 150 industry and regulatory frameworks, including Siberwander Orca Best Practices and a wide range of CIS control benchmarks.</li>
            <li>Unlike other CSPMs, Siberwander Orca also discovers sensitive data in your cloud environment and notifies you when data, such as PII, is vulnerable through potential exploitation paths.</li>
            <li>With this insight, Siberwander Orca helps organizations prioritize data security and demonstrate their compliance with mandates such as PCI-DSS, GDPR, HIPAA, and CCPA.</li>
          </ul>
        `,
      },
      {
        image: b_feature3,
        title: "Remediate risks at the speed of the cloud",
        description: `
          <p class="text-justify">Siberwander Orca offers auto remediation and guided remediation options, helping you to quickly address any detected risks – reducing your Mean Time to Remediation (MTTR) and improving your cloud security posture.</p>
          <ul class="text-justify">
            <li>Configure automation rules that remediate alerts as soon as they are detected without requiring any manual intervention.</li>
            <li>Generate high-quality remediation instructions for each alert leveraging generative AI built into the Siberwander Orca platform.</li>
            <li>Copy and paste remediation code into a command line interface or Infrastructure as Code (IaC) provisioning tools, or follow steps in the console.</li>
          </ul>
        `,
      },
      {
        image: b_feature4,
        title: "Easily search your cloud environment",
        description: `
          <p class="text-justify">Leveraging AI, Siberwander Orca greatly simplifies searches by enabling users to ask natural language questions – significantly reducing time-to-discovery and improving compliance.</p>
          <ul class="text-justify">
            <li>Ask plain language questions such as ‘Do I have any vulnerabilities that are public facing?’ or “Do I have any unencrypted databases with sensitive data exposed to the Internet?”</li>
            <li>Regardless of skill level, Siberwander Orca allows users across the organization to easily understand exactly what’s in their cloud environment.</li>
            <li>Advanced users can craft complex and granular queries much faster than when having to code in a proprietary query language.</li>
          </ul>
        `,
      },
    ],
    faqs: [
      {
        question: "What is CSPM?",
        answer: `
          <p>Cloud Security Posture Management (CSPM) is a cloud security solution that enables organizations to identify and remediate risks and any misconfigurations in their cloud infrastructure so they can reduce their attack surface.</p>
          <br/>
          <p>Gartner first named CSPMs as a cloud security category in 2014. CSPMs emerged as a necessary solution to help organizations maintain the proper configurations of cloud services as they migrated to popular public cloud environments such as AWS, Azure, and Google Cloud.</p>
          <br/>
          <p>CSPMs remain a popular cloud security solution. According to Gartner, the CSPM market is expected to grow in the coming years, with annual revenues predicted to reach $3.32 billion by 2027. Still, a subsequent Gartner analysis estimates that 75% of new CSPM purchases will come from cloud native application protection platforms (CNAPPs) by 2025.</p>
        `
      },
      {
        question: "Why is CSPM important?",
        answer: `
        <p>Cloud misconfigurations are a top cloud security concern. Several factors increase their likelihood, including insufficient monitoring, unrestricted access controls, mismanaged secrets, unreviewed default values, and more. According to a Gartner survey, misconfigurations cause 80% of all data security breaches, and predictions are that until 2025, 99% of cloud environment failures will be attributed to human errors.</p>
        <br/>
        <p>As a segment of cloud security tools, CSPMs play an important role in continuously monitoring cloud infrastructure for gaps in security policy enforcement. They automatically identify misconfigurations across cloud infrastructures, and in some cases remediate them too. As a result, CSPMs can help organizations save money, identify security risks, and educate teams.</p>
        `
      },
      {
        question: "How does CSPM work?",
        answer: `
        <p>A CSPM helps security teams remediate misconfigurations and maintain compliance by monitoring the cloud control plane and ensuring that it aligns with defined security policies. More specifically, a CSPM:</p>
        <ul>
          <li><b>Maintains a cloud asset inventory:</b> Creates and maintains an organized inventory of all cloud infrastructure.</li>
          <li><b>Ensures cloud compliance:</b> On an ongoing basis, tracks cloud assets for compliance against relevant regulatory frameworks and industry benchmarks.</li>
          <li><b>Defines and enforces policies:</b> Identifies and enforces policies for accessing data and compliance reporting.</li>
          <li><b>Detects cloud threats:</b> Identifies risks in your cloud infrastructure and creates alerts for remediation.</li>
          <li><b>Facilitates incident response:</b> Assists incident response by presenting relevant information and guidance needed to remediate risks or compliance issues.</li>
        </ul>
        `
      },
      {
        question: "What are the limitations of CSPM for cloud security?",
        answer: `
        <p>CSPMs are essential for cloud security, however traditional CSPM solutions present important limitations, including:</p>
        <ul>
          <li><b>Only cover control plane:</b> CSPMs provide visibility into cloud configurations (control plane) but not cloud workloads (data plane). As a result, they have no insight into vulnerabilities, malware, or exposed secrets.</li>
          <li><b>Alert fatigue:</b> Without visibility into workloads, CSPM solutions lack the unified insight to fully contextualize risks and prioritize alerts based on the full context.</li>
          <li><b>No identity and permissions management:</b> CSPM tools also don’t manage access controls, permissions, or entitlements. To support and enforce the principle of least privilege (PoLP), organizations need a cloud infrastructure entitlement management (CIEM) solution.</li>
        </ul>
        <p>For this reason, CNAPPs (Cloud-Native Application Protection Platforms) have emerged to address the challenges of using siloed traditional cloud security solutions. A CNAPP is a cloud security solution that detects risks across the full technology stack (control plane and data plane), including cloud misconfigurations, mismanaged identity access, vulnerabilities, malware and data at risk.</p>
        `
      },
      {
        question: "What are the advantages of Siberwander Orca vs. siloed Cloud Security Posture Management (CSPM)?",
        answer: `
        <p>Traditional CSPM tools pull metadata via the cloud provider’s APIs to obtain visibility into the cloud infrastructure, but only identify simple control plane misconfigurations and have limited insight into overall workload risk posture. CSPM tools can only detect risks such as malware and vulnerabilities at the cloud infrastructure layer, leaving a significant portion (OS, application, and data) of the cloud estate exposed. In addition, because they have a limited perspective on data risk, CSPM tools lack insight as to where sensitive data might be stored and the potential for its exposure.</p>
        <br/>
        <p>In contrast, as a CNAPP, Siberwander Orca combines CSPM, CWPP, CIEM and more in a single platform, and provides full-stack visibility of your cloud estate—that is, visibility that spans the cloud infrastructure, OS, application, and data layers—ensuring you have complete security and compliance coverage.</p>
        `
      }
    ]
  },
  {
    url: 'cloud-workload-protection-platform',
    title: 'Cloud Workload Protection Platform (CWPP)',
    desc: 'Security for VMs, containers, and Kubernetes delivered with an agentless-first approach',
    challenge: 'Modern Applications Present Challenges to Traditional CWPP Approaches',
    challenge_desc: 'Agent-based and EDR-based CWPPs require tedious deployments and management for each workload, leading to limited visibility for security teams and high operational overhead. Vendors have tried to offer a “choice” between agents and agentless approaches, but only add to the complexity and often have hidden limits on their ‘agentless’ capabilities. In addition, CWPPs only cover cloud workloads and miss risks in the cloud control plane, such as misconfigurations and overly permissive identities.',
    partner_info: [
      {
        title: 'Blind Spots in Deployment',
        description: 'Partial deployment of agents causes serious blind spots.'
      },
      {
        title: 'Time-Consuming Agent Management',
        description: 'IT teams need to spend countless hours installing, configuring, and maintaining agents.'
      },
      {
        title: 'Performance and Security Risks',
        description: 'Agents and network scanners have a significant performance impact and can be a security risk.'
      },
      {
        title: 'Organizational Friction',
        description: 'Security teams often need to burden development and DevOps teams to install agents, creating organizational friction.'
      },
      {
        title: 'Cloud Security Gaps',
        description: 'CWPPs don’t have insight into cloud configurations and identities, leaving important security gaps.'
      },
    ],
    features: [
      {
        image: c_feature1,
        title: "Cloud workload protection starts with risk prioritization",
        description: `
          <p class="text-justify">Siberwander Orca identifies all your VMs, containers, Kubernetes clusters, and serverless functions and leverages 20+ vulnerability data sources to discover and prioritize vulnerabilities across your entire cloud estate.</p>
          <ul class="text-justify">
            <li>Siberwander Orca’s workload inventory includes information on OS packages, applications, libraries, as well as versions and other identifying characteristics.</li>
            <li>Siberwander Orca goes beyond just a mere CVSS score to consider the context of cloud assets, their connections and risks, to understand which vulnerabilities need to be addressed first.</li>
            <li>In rapid response situations such as Log4Shell, Siberwander Orca allows you to quickly identify vulnerable cloud assets and prioritize patching the ones that pose the greatest risk to the business.</li>
          </ul>
        `,
      },
      {
        image: c_feature2,
        title: "Protect your sensitive data with CWPP coverage",
        description: `
          <p class="text-justify">Siberwander Orca scans the hidden corners of your cloud estate, searching for at-risk sensitive data, from personally identifiable information (PII) to protected healthcare information, and more.</p>
          <ul class="text-justify">
            <li>Detect at-risk sensitive data on every workload across your cloud estate regardless of whether the assets are running, idle, paused, or stopped.</li>
            <li>Sensitive data detection includes PII, including physical addresses, email addresses, credit card numbers, and Social Security identifiers.</li>
            <li>Understand which risk combinations are a straight attack path to your crown jewels.</li>
          </ul>
        `,
      },
      {
        image: c_feature3,
        title: "Detect known and unknown malware",
        description: `
          <p class="text-justify">Siberwander Orca uses extensive malware detection techniques to locate known and potentially malicious code in your cloud workloads and resources.</p>
          <ul class="text-justify">
            <li>Signature-based scanning checks for file hashes of known malware.</li>
            <li>Heuristic file analysis closely inspects files to determine their purpose, destination, and intent.</li>
            <li>Dynamic scanning executes a file in a controlled virtual environment to observe its actions.</li>
            <li>Genetic signature detection uses previous malware definitions to discover malware within the same family.</li>
          </ul>
        `,
      },
      {
        image: c_feature4,
        title: "Leverage lightweight runtime protection for VMs and containers",
        description: `
          <p class="text-justify">Siberwander Orca Sensor enables you to gain powerful runtime protection for your critical workloads—all from a lightweight, eBPF-based technology deeply integrated with the Siberwander Orca Platform.</p>
          <ul class="text-justify">
            <li>Gain advanced, reliable protection with fast and simple deployments, automatic updates, and minimal maintenance for runtime security that doesn’t burden your teams.</li>
            <li>Get a real-time view of activity, threats, and malicious behavior flows directly from the Siberwander Orca Platform.</li>
            <li>Leverage an extensive range of runtime detections that reinforce Siberwander Orca’s comprehensive risk discovery, with the ability to build custom detections as needed.</li>
          </ul>
        `,
      },
    ],
    faqs: [
      {
        question: "What is CWPP?",
        answer: `
        <p>A Cloud Workload Protection Platform (CWPP) is a cloud security solution dedicated to securing server workloads in the public cloud. CWPP solutions discover and detect risks in cloud workloads, including vulnerabilities, malware, and sensitive data at risk. CWPP capabilities are offered through standalone solutions or as part of cloud-native application protection platforms (CNAPP).</p>
        `
      },
      {
        question: "Why is CWPP important?",
        answer: `
        <p>Public cloud services operate according to what’s called the shared responsibility model, an agreement between cloud service providers and their customers. The model makes each party responsible for certain aspects of cloud security:</p>
        <ul>
          <li><b>Cloud service providers</b> are responsible for the physical access and infrastructure of their services.</li>
          <li><b>Organizations</b> are responsible for securing the applications, services, and data they run and store on their cloud instances.</li>
        </ul>
        <p>CWPP tools (either as standalone solutions or as part of a more comprehensive CNAPP) are necessary to provide visibility into and security for workloads, which are essential to meet the obligations of the shared responsibility model.</p>
        `
      },
      {
        question: "How does CWPP work?",
        answer: `
        <p>CWPPs are vital to securing cloud-native workloads. Traditional CWPPs require an agent to be installed on every asset to be monitored, which leads to incomplete coverage, high TCO, and performance degradation. However, modern CWPP solutions such as the Siberwander Orca Platform provide 100% coverage of workloads without requiring a single agent.</p>
        `
      },
      {
        question: "What are the limitations of a CWPP?",
        answer: `
        <p>Despite being a crucial cloud security solution, CWPP tools present important limitations, including:</p>
        <ul>
          <li><b>No visibility into the control plane:</b> CWPPs only provide visibility into and security for workloads, not the cloud control plane, including misconfigurations such as publicly exposed storage buckets.</li>
          <li><b>Inability to contextualize risks:</b> Because CWPP solutions can’t see into the cloud control plane, they also can’t account for contextual factors that may make a risk more or less severe. As a result, they can’t effectively alert teams and prioritize their efforts to focus on the most critical risks.</li>
          <li><b>Limited coverage:</b> Traditional CWPPs are agent-based and therefore require individual agents to be installed and maintained for every cloud asset. This creates blind spots in cloud security. However modern CWPPs, such as the Siberwander Orca Platform, provide instant 100% workload coverage and combine CWPP with other cloud security capabilities such as CSPM, CIEM, DSPM, and more.</li>
          <li><b>No detection for lateral movement:</b> Without an additional solution, CWPP tools can’t identify keys that hackers could exploit to move laterally and access other assets.</li>
        </ul>
        `
      },
      {
        question: "What are the advantages of Siberwander Orca vs. traditional Cloud Workload Protection Platforms (CWPP)?",
        answer: `
        <p>Agent-based CWPPs require tedious deployments and management for each workload, leading to high TCO. Vendors offering a choice between agents and agentless approaches only add to the complexity and often have hidden limits on their ‘agentless’ capabilities. In addition, CWPPs only cover cloud workloads and miss risks in the cloud control plane, such as misconfigurations and overly permissive identities.</p>
        <br/>
        <p>This limited visibility impacts the tool’s ability to provide full security coverage and effective alert prioritization. Any risks due to cloud misconfiguration (such as MFA not being enabled for the ‘root’ user account or KMS encryption keys not being rotated) cannot be detected by a CWPP. This lack of visibility also means CWPPs lack the context necessary to understand the full implications of a security issue and are therefore unable to prioritize alerts based on environmental context. This causes “swivel chair” alert triage, which leads to alert fatigue.</p>
        <br/>
        <p>The Siberwander Orca Platform provides full-stack visibility of your cloud estate, spanning the cloud infrastructure, OS, application, and data layers, without requiring a single agent and providing instant and continuous 100% coverage of your cloud assets.</p>
        `
      }
    ]
  },
  {
    url: 'cloud-infrastructure-entitlement-management',
    title: 'Cloud Infrastructure Entitlement Management (CIEM)',
    desc: 'Secure identities and cloud entitlements and ensure least privilege permissions',
    challenge: 'Standalone CIEM Solutions Lack Wider Cloud Context',
    challenge_desc: 'Cloud identities present risks to organizations as they are a central component of every environment and cloud native application. Monitoring the effective management and auditing of cloud identities and permissions across multi-cloud environments requires comprehensive visibility and automation, which is lacking in point CIEM tools. Without the visibility into unmanaged identities, such as SSH keys, passwords, or account roles, security teams struggle to achieve comprehensive cloud security at scale.',
    partner_info: [
      {
        title: 'Streamlined Cloud Management',
        description: 'Manually configuring and auditing cloud entitlements is inefficient and leads to misconfiguration errors.'
      },
      {
        title: 'Enhanced Risk Visibility',
        description: 'Point solutions don’t have visibility into workload risks and unmanaged identities, such as SSH keys, passwords, and other critical issues, thereby limiting visibility into wider cloud context.'
      },
      {
        title: 'Improved Compliance and Revenue',
        description: 'The result is poor risk prioritization, inaccurate or contextless remediation, and incomplete compliance.'
      },  
    ],
    features: [
      {
        image: d_feature1,
        title: "Centralized multi-cloud discovery and compliance",
        description: `
          <p class="text-justify">Siberwander Orca’s agentless platform allows you to track cloud assets, roles, and entitlements across multiple cloud platforms, and ensure compliance with regulatory standards and CIS benchmarks.</p>
          <ul class="text-justify">
            <li>Get granular, contextual visibility into all identities, configurations, access policies, entitlements, permissions, and activities in your cloud.</li>
            <li>View network access and publicly exposed resources in all of your cloud estate.</li>
            <li>Leverage over 1,300 controls across 20+ categories, including authentication, data protection, logging and monitoring, IAM misconfigurations, and system integrity.</li>
          </ul>
        `,
      },
      {
        image: d_feature2,
        title: "Advanced querying of identity and entitlement risks",
        description: `
          <p class="text-justify">Siberwander Orca allows you to perform advanced queries on entitlement and identity data, using 1300+ built-in alert templates or custom queries created with Siberwander Orca’s intuitive query builder.</p>
          <ul class="text-justify">
            <li>Set up customized alerts—with remediation actions—to be notified when cloud developers violate the least-privilege principle or other security policies</li>
            <li>Support continuous compliance query templates that align with 100+ regulatory frameworks and CIS benchmarks</li>
            <li>Integrate queries and alerts with your existing workflows and ticketing systems.</li>
          </ul>
        `,
      },
      {
        image: d_feature3,
        title: "Find insecurely stored keys before attackers do",
        description: `
          <p class="text-justify">Unlike point solution CIEM products, Siberwander Orca scans your unmanaged identities and other telemetry across the entire cloud estate for exposed keys, passwords in shell history, and other information that an attacker can leverage to move laterally in your environment.</p>
          <ul class="text-justify">
            <li>Siberwander Orca scans each machine’s file system for private keys and creates hashes of all discovered keys. Then Siberwander Orca scans all other assets for authorized public key configurations with matching hashes.</li>
            <li>Siberwander Orca surfaces key-related information including paths to insecurely stored keys, workloads that can be accessed with exposed keys, and stored user accounts and permissions.</li>
            <li>Siberwander Orca discovers any remote access keys, including cloud service provider keys, SSH keys, and more, that might allow attackers to access additional sensitive resources.</li>
          </ul>
        `,
      },
      {
        image: d_feature4,
        title: "Reduce IAM risk with multiple remediation options",
        description: `
          <p class="text-justify">Using prescriptive analytics and artificial intelligence, Siberwander Orca calculates the largest security improvements that can be made with the least policy changes, and provides teams with guided remediation steps to reduce IAM risk. Users can implement custom remediation based on their own playbooks for an alert, on-demand remediation directly from Siberwander Orca telemetry, or automated remediation directly from Siberwander Orca.</p>
          <ul class="text-justify">
            <li>Siberwander Orca compares existing IAM policies to actual policy usage from the previous 90 days to recommend the largest security improvements with the least amount of effort.</li>
            <li>Ensure that a high level of IAM hygiene and compliance is maintained without overburdening security teams.</li>
            <li>Easily consume the IAM remediation actions as a file download, convert it into AWS IAM policies, and deploy it into your cloud account.</li>
          </ul>
        `,
      },
      {
        image: d_feature5,
        title: "Detect and respond to cloud attacks",
        description: `
          <p class="text-justify">Siberwander Orca allows teams to quickly identify and respond to cloud attacks by continuously collecting and analyzing intelligence from cloud feeds, workloads, configurations and identities in a single platform.</p>
          <ul class="text-justify">
            <li>Detect: Receive alerts when malicious user activities occur, such as compromised accounts and stolen access keys.</li>
            <li>Investigate: Research flagged activity to quickly gain insight into whether the events are malicious and if any of the organization’s critical assets are in danger.</li>
            <li>Respond: Intercept cloud attacks by leveraging remediation steps and automatically assigning issues using Siberwander Orca’s 20+ third-party technical integrations (including SOAR, notifications, and ticketing systems).</li>
          </ul>
        `,
      },
      {
        image: d_feature6,
        title: "Attack path visualization and prioritization",
        description: `
          <p class="text-justify">By analyzing all the risks and vulnerabilities across all layers of your cloud environment, Siberwander Orca discovers dangerous risk combinations that could result in a direct path to your critical assets, so security teams can focus on what matters most.</p>
          <ul class="text-justify">
            <li>Siberwander Orca presents each attack path in a visual graph with contextual data on the relevant cloud entities (IAM, compute, storage, etc.) and the relations between them.</li>
            <li>By focusing on a much smaller number of prioritized attack paths, teams don’t need to sift through hundreds of siloed alerts.</li>
            <li>Siberwander Orca shows teams exactly which issues need to be remediated to diffuse the attack path.</li>
          </ul>
        `,
      },
    ],
    faqs: [
      {
        question: "What is CIEM?",
        answer: `
        <p>Cloud Infrastructure Entitlements Management (CIEM) is a type of cloud security solution designed to manage access rights and permissions for cloud resource entities. CIEM (pronounced “KIM”) solutions are necessary for implementing the principle of least privilege (PoLP), a security strategy that ensures users only get access to the resources they strictly need to perform their jobs.</p>
        <br/>
        <p>CIEM tools are gaining importance amid the continued increase in cloud deployments, infrastructures, and the sheer number of available entitlements.</p>
        `
      },
      {
        question: "Why is CIEM important?",
        answer: `
        <p>CIEM enables organizations to successfully manage identity and resource access across rapidly changing cloud environments. Using a CIEM solution, organizations can strengthen their cloud security posture and benefit from compliance assurance, scalable entitlements visibility, cloud permission rightsizing, and automated detection and remediation of access risks.</p>
        <br/>
        <p>Three important benefits of CIEMs include:</p>
        <ul>
          <li><b>Support and compliance for multi-cloud environments:</b> CIEM solutions can provide centralized visibility and compliance for multi-cloud environments. This enables security teams to track cloud assets, compute pieces, services, roles, and entitlements across multiple cloud platforms while ensuring compliance.</li>
          <li><b>Automatic remediation:</b> CIEM tools can automatically detect and remediate identity and access management (IAM) issues when it comes to entitlements management.</li>
          <li><b>Continuous validation for cloud infrastructure entitlements:</b> CIEM solutions enable security teams to assess cloud infrastructure entitlements easily and effectively. These tools provide visibility into cloud identities, access policies, entitlements, configurations, permissions, and activities.</li>
        </ul>
        `
      },
      {
        question: "How does CIEM work?",
        answer: `
        <p>To ensure organizations manage cloud asset rights and permissions according to the least-privilege principle, CIEM solutions follow a continuous process that involves the following activities:</p>
        <ul>
          <li><b>Scan environment:</b> CIEM solutions analyze the cloud environment to inventory all cloud assets, users, and entitlements.</li>
          <li><b>Inventory cloud estate:</b> CIEM tools use this information to build a comprehensive view of the cloud estate and any risks associated with entitlements.</li>
          <li><b>Perform automated remediation:</b> After scanning the cloud environment, CIEM tools automatically remediate identified issues, including revoking unnecessary privileges from overly permissioned roles, stopping unauthorized access, and more.</li>
          <li><b>Continuously monitor and alert:</b> CIEM solutions also continuously monitor the cloud environment for new issues and alert security teams to potential threats or policy issues.</li>
          <li><b>Generate compliance reports:</b> CIEM tools produce reports that help organizations audit and comply with regulatory frameworks and industry benchmarks.</li>
        </ul>
        `
      },
      {
        question: "What types of risks does CIEM identify?",
        answer: `
        <p>Siberwander Orca’s CIEM solution identifies the following risks:</p>
        <ul>
          <li>Privileged roles with cross-account trust</li>
          <li>Inactive IAM roles with admin privileges</li>
          <li>Unattached privileged policies</li>
          <li>Most active roles with cross-account trust</li>
          <li>Compromised assets with privileged IAM permissions</li>
          <li>Privileged inactive identities</li>
        </ul>
        <p>In addition to detecting siloed identity risks, Siberwander Orca uses attack path analysis to identify compound risk, i.e. when identity risks can be combined with other risks to create dangerous attack paths.</p>
        `
      },
      {
        question: "How does Siberwander Orca’s CIEM dashboard provide value?",
        answer: `
        <p>Siberwander Orca provides Cloud Infrastructure Entitlements Management (CIEM) by:</p>
        <ul>
          <li>Promoting identity hygiene, including enforcement of Principle of Least Privilege (PoLP).</li>
          <li>Detecting deviations from identity best practices.</li>
          <li>Using identity data to help understand and prioritize the risks that are found in your system.</li>
          <li>Calculating optimal policy configurations based on role usage in the past 90 days, using Siberwander Orca’s IAM Policy Optimizer.</li>
        </ul>
        `
      }
    ]
  },
  {
    url: 'data-security-posture-management',
    title: 'Data Security Posture Management (DSPM)',
    desc: 'Discover all sensitive data, address data risks, and adhere to privacy regulations',
    challenge: 'Cloud Data Security Tools Fall Short',
    challenge_desc: 'With data scattered across multiple clouds and data stores, security teams need continuous visibility into where their sensitive data resides, who has access, and which data is at risk. Existing data security tools, however, are lacking in essential areas, such as automated data discovery, integrating data intelligence with other cloud risks, or delivering DSPM telemetry without requiring additional tools and integrations.',
    partner_info: [
      {
        title: 'Modern Cloud Adaptation',
        description: 'Legacy DLP tools rely on overburdened IT teams for manual data classification and struggle to keep pace in the cloud.'
      },
      {
        title: 'Comprehensive Security Context',
        description: 'DSPM-only tools lack the wider context of cloud misconfigurations, vulnerabilities, exposed APIs, lateral movement risks and other threats.'
      },
      {
        title: 'Cost-Efficient Integrations',
        description: 'Platforms that require integration with third-party data security tools lead to higher costs, contradicting alerts, and inefficiency.'
      },
    ],
    features: [
      {
        image: e_feature1,
        title: "Discover and classify data in your cloud",
        description: `
          <p class="text-justify">Siberwander Orca’s DSPM dashboard provides data security teams with an overview of their cloud data stores, sensitive data, and security and compliance alerts. Siberwander Orca scans managed, unmanaged, and shadow data, giving security teams wide and deep visibility into where their data resides.</p>
          <ul class="text-justify">
            <li>Get a multi-cloud inventory of data storage assets—including databases, and files in virtual machines, storage buckets, and containers.</li>
            <li>Know which data stores contain sensitive data and of what type—including PII, PCI, PHI, or financial information—for both security and regulatory purposes.</li>
            <li>Leverage interactive graphs that show the location and relationship between data stores and other cloud entities.</li>
          </ul>
        `,
      },
      {
        image: e_feature2,
        title: "Shrink the data attack surface",
        description: `
          <p class="text-justify">Siberwander Orca scans the entirety of your cloud estate, surfacing direct and indirect data risks, allowing security teams to take preventive steps to reduce their data attack surface.</p>
          <ul class="text-justify">
            <li>Detect and prioritize risks that endanger sensitive data on managed and self-hosted databases, and every workload across your cloud estate.</li>
            <li>Understand how dangerous attack paths can be formed through the combination of data misconfigurations with other cloud risks including vulnerabilities, malware, lateral movement risks, and API risks.</li>
            <li>Leverage actionable risk telemetry, indicating the location of sensitive data and masked data samples for efficient triaging and remediation.  </li>
          </ul>
        `,
      },
      {
        image: e_feature3,
        title: "Ensure continuous data compliance",
        description: `
          <p class="text-justify">Siberwander Orca provides a single, unified cloud security platform for verifying that sensitive data stores comply with regulatory frameworks and industry benchmarks, including data privacy requirements.</p>
          <ul class="text-justify">
            <li>Be alerted when the storage of sensitive data violates compliance regulations.</li>
            <li>Leverage 150+ out-of-the-box templates—or build custom frameworks—to quickly understand and measure compliance across clouds.</li>
            <li>Stay ahead of audits and adhere to common compliance frameworks such as PCI-DSS, GDPR, HIPAA, and CCPA.</li>
          </ul>
        `,
      },
      {
        image: e_feature4,
        title: "Monitor data activity",
        description: `
          <p class="text-justify">Siberwander Orca continually monitors for suspicious activity that could endanger your organization’s sensitive data, so you can quickly investigate and triage any potential breaches.</p>
          <ul class="text-justify">
            <li>Be alerted to active anomalous access patterns and other suspicious events and behaviors that could indicate potential data exfiltration attempts.</li>
            <li>For every alert, a detailed timeline of events is provided, as well as recommended remediation steps, enabling you to rapidly lower security risks.</li>
            <li>Keep a real-time inventory of all cloud data, including its location and security posture. Across the entire Software Development Lifecycle.</li>
          </ul>
        `,
      },
    ],
    faqs: [
      {
        question: "What is DSPM?",
        answer: `
        <p>Data Security Posture Management (DSPM) is a cloud security solution that detects sensitive data, such as PII (Personal Identifiable Information), PHI (Personal Health Information), financial data, intellectual property, and more, and analyzes and remediates any associated security risks or compliance issues.</p>
        <br/>
        <p>In 2022, Gartner first introduced the category name “Data Security Posture Management (DSPM)” in an effort to classify a new breed of data security solutions. Unlike legacy data security technologies, DSPM takes a cloud-native approach to securing data in the cloud.</p>
        `
      },
      {
        question: "Why is DSPM important?",
        answer: `
        <p>Securing sensitive data is one of the main focal points of cloud security. While enterprises are increasingly moving their data to the cloud, security teams are given the unenvious task of keeping this data secure.</p>
        <br/>
        <p>A 2022 Forrester report on The State Of Data Security found that 46% of security decision-makers whose organizations experienced a breach in the previous year said that PII was targeted. Additionally, during a time of global pandemic, 36% said that protected health information (PHI) was a common type of data that was compromised.</p>
        `
      },
      {
        question: "How does CIEM work?",
        answer: `
        <p>DSPM solutions perform several important functions to ensure data security and integrity, including:</p>
        <ul>
          <li>Scanning and inventorying data across the cloud estate.</li>
          <li>Identifying where sensitive data lives and who has access to it.</li>
          <li>Discovering and eliminating shadow data to minimize the data attack surface.</li>
          <li>Preventing sensitive data exposure by addressing over-privileged access, data store misconfigurations, and other risks in the environment.</li>
          <li>Maintaining continuous multi-cloud compliance with sensitive data storage requirements.</li>
        </ul>
        `
      },
      {
        question: "What are the challenges of DSPM?",
        answer: `
        <p>Despite its benefits, DSPM also presents important technological challenges, including:</p>
        <ul>
          <li><b>Lack of unified context:</b> DSPM, when offered as a standalone solution, lacks wide risk visibility into the cloud estate. This leads to an incomplete awareness of the factors that may put sensitive data at risk, such as API misconfigurations, workload vulnerabilities, or other cloud misconfigurations.</li>
          <li><b>Tool sprawl:</b> Standalone DSPM solutions require organizations to purchase additional cloud security solutions for complete coverage. This forces security teams to use and manage a siloed solution, decreasing productivity through inefficiencies and duplicative work, while increasing licensing costs.</li>
          <li><b>Legacy solutions:</b> Organizations may rely on data loss prevention (DLP) tools for their DSPM needs. As a legacy solution originally designed for on-prem environments, DLP provides a limited inventory of sensitive data and where it lives in the cloud, requiring security teams to manually classify data to prevent data leakage.</li>
        </ul>
        `
      },
      {
        question: "How does Siberwander Orca’s DSPM enhance data security?",
        answer: `
        <p>Siberwander Orca Cloud Security Platform provides the key capabilities of a DSPM solution, and our comprehensive approach to cloud security means that data security is natively included in a single cloud security platform, without requiring any further integrations.</p>
        <br/>
        <p>In addition, as opposed to DSPM tools that focus solely on data security, Siberwander Orca takes a holistic view that combines data intelligence with other cloud risks.This includes vulnerabilities, malware, misconfigurations, lateral movement risks, identity and access risks, API risks, and more.This comprehensive insight allows Siberwander Orca to highlight how indirect as well as direct risks can lead to exposed sensitive data.</p>
        <br/>
        <p>Siberwander Orca’s SideScanning™ technology, which collects data from the workload runtime block storage without requiring agents, performs a complete data risk analysis with no performance impact. This provides security teams with comprehensive visibility of their data storage across the entire cloud estate, including misplaced sensitive data stores and shadow data.</p>
        `
      }
    ]
  },
  {
    url: 'container-and-kubernetes-security',
    title: 'Container and Kubernetes Security',
    desc: 'Perform extensive security checks at every cloud layer, without requiring agents',
    challenge: 'Agents Weren’t Designed for Cloud Native Applications',
    challenge_desc: 'Agents Weren’t Designed for Cloud Native Applications',
    partner_info: [
      {
        title: 'Eliminate Blind Spots',
        description: 'Partial deployment of agents causes serious blind spots and agents can have a significant performance impact on applications.'
      },  
      {
        title: 'Simplified Operations',
        description: 'Security and DevOps teams need to spend countless hours installing, configuring, and maintaining agents, creating organizational friction.'
      },  
      {
        title: 'Cloud Security Insights',
        description: 'No insight into cloud configurations and identities leaves important security gaps.'
      },  
    ],
    features: [
      {
        image: f_feature1,
        title: "Agentless container and Kubernetes security",
        description: `
          <p class="text-justify">Siberwander Orca’s patented SideScanning™ technology is a radical new approach that addresses the shortcomings of agent-based cloud security solutions.</p>
          <ul class="text-justify">
            <li>Siberwander Orca collects data directly from your cloud configuration and the workload’s runtime block storage out-of-band.</li>
            <li>Within minutes, Siberwander Orca finds and prioritizes your most critical cloud risks, including vulnerabilities, malware, misconfigurations, lateral movement risks, IAM risks, and sensitive data at risk.</li>
            <li>Unlike other solutions, Siberwander Orca combines workload-deep intelligence with cloud configuration metadata all in one platform.</li>
          </ul>
        `,
      },
      {
        image: f_feature2,
        title: "Vulnerability management across hosts and images",
        description: `
          <p class="text-justify">Siberwander Orca creates a full inventory of your cloud environment and leverages 20+ vulnerability data sources to discover and prioritize vulnerabilities across your entire cloud estate.</p>
          <ul class="text-justify">
            <li>Siberwander Orca’s workload inventory includes information on OS packages, applications, libraries, as well as versions and other identifying characteristics.</li>
            <li>Unlike other solutions that simply report on the CVSS score, Siberwander Orca considers the context of cloud assets, their connections and risks, to understand which vulnerabilities need to be addressed first.</li>
            <li>In rapid response situations such as Log4Shell, Siberwander Orca allows you to quickly identify vulnerable cloud assets and prioritize patching the ones that pose the greatest risk to the business.</li>
          </ul>
        `,
      },
      {
        image: f_feature3,
        title: "Full stack compliance for your entire application",
        description: `
          <p class="text-justify">Siberwander Orca supports over 100 out-of-the-box compliance templates enabling fast, effective compliance and reporting. For modern cloud native applications, leverage and customize the Center for Internet Security (CIS) Benchmarks, including Docker, Kubernetes, Linux and more.</p>
          <ul class="text-justify">
            <li>Leverage pre-built compliance templates for vital industry frameworks, such as PCI-DSS, HIPAA, GDPR, SOC 2 and more</li>
            <li>Quickly and effectively enable CIS Benchmarks, supporting Linux and Windows hosts, Docker, Kubernetes, and other cloud native technologies</li>
            <li>Integrate compliance checks into the CI/CD lifecycle to enforce compliance policies and best practices</li>
          </ul>
        `,
      },
      {
        image: f_feature4,
        title: "Detect and respond to cloud attacks",
        description: `
          <p class="text-justify">With Siberwander Orca’s CDR capabilities, organizations can detect, investigate, and respond to cloud attacks in progress:</p>
          <ul class="text-justify">
            <li>Detect: Receive alerts when changes and anomalies occur that indicate possible malicious intent versus normal behavior, automatically prioritizing events that endanger the company’s most critical assets.</li>
            <li>Investigate: Research malicious activity to quickly gain insight into whether the events are malicious and if any of the organization’s critical assets are in danger.</li>
            <li>Respond: Intercept cloud attacks by leveraging remediation steps and automatically assigning issues using Siberwander Orca’s 20+ third-party technical integrations (including SOAR, notifications, and ticketing systems).</li>
          </ul>
        `,
      },
    ],
    faqs: []
  },
  {
    url: 'multi-cloud-compliance',
    title: 'Multi-Cloud Compliance',
    desc: 'Achieve continuous multi-cloud security compliance with 150+ frameworks and CIS benchmarks',
    challenge: 'Partial Coverage, Compliance Gaps, and Disparate Solutions',
    challenge_desc: 'Multi-cloud compliance calls for complete, continuous coverage of your entire cloud estate. However, relying on tools that require agents and approach compliance on a per-asset basis results in gaps in coverage, increased cybersecurity risk, organizational friction, and failed audits. In addition, using multiple point solutions or poorly integrated offerings only increases manual work correlating data and aligning policies.',
    partner_info: [
      {
        title: 'Complete Cloud Compliance',
        description: 'Compliance is not achievable without 100% coverage of your entire cloud estate. On average, less than 50% of assets are covered by agent-based solutions.'
      },
      {
        title: 'Unified Security Policies',
        description: 'Most CSP native security tools are specific to each platform, resulting in the need to maintain and align policies across disparate solutions.'
      },
      {
        title: 'Customizable Compliance Frameworks',
        description: 'Although dedicated compliance solutions exist, lack remediation techniques, and do not provide the ability to create custom frameworks.'
      },
    ],
    features: [
      {
        image: g_feature1,
        title: "Easily tailor frameworks to your needs",
        description: `
          <p class="text-justify">Recognizing that one size does not always fit all, Siberwander Orca also offers users the ability to configure custom compliance frameworks.</p>
          <ul class="text-justify">
            <li>Use existing templates or build new frameworks from scratch.</li>
            <li>Make tweaks to existing frameworks, combine rules from two or more frameworks, or set up your own rules and controls.</li>
            <li>Customize notification schedule, prioritization of controls, and other settings.</li>
          </ul>
        `,
      },
      {
        image: g_feature2,
        title: "Find and protect sensitive data",
        description: `
          <p class="text-justify">Siberwander Orca scans your entire cloud estate to discover sensitive data that is not properly protected and causes a compliance gap.</p>
          <ul class="text-justify">
            <li>Understand where sensitive data resides in your cloud, including PII stored in managed, self-hosted, and shadow data stores and files.</li>
            <li>Meet key data privacy mandates such as PCI-DSS, GDPR, HIPAA, SOC 2, and CCPA.</li>
            <li>Leverage Siberwander Orca risk prioritization to ensure that issues endangering your sensitive data and other business critical assets are addressed first.</li>
          </ul>
        `,
      },
      {
        image: g_feature3,
        title: "Automate remediation workflows",
        description: `
          <p class="text-justify">Using Siberwander Orca’s many technical integrations, organizations can integrate compliance alerts into their existing remediation workflows, ensuring that issues are automatically assigned and processed by the right teams.</p>
          <ul class="text-justify">
            <li>Automatically forward compliance alerts to email, PagerDuty, OpsGenie, or Slack, or assign issues through ticketing systems, such as Jira or ServiceNow.</li>
            <li>Address risks quickly with automated and AI-powered guided remediation to avoid compliance violations.</li>
            <li>Rich contextual information is provided with alerts to allow remediation teams to operate independently and efficiently.</li>
          </ul>
        `,
      },
      {
        image: g_feature4,
        title: "Avoid releasing non-compliant applications",
        description: `
          <p class="text-justify">Siberwander Orca provides compliance checks across the full software development lifecycle (SDLC), including IaC template, container image, and container registry scanning, so teams can:</p>
          <ul class="text-justify">
            <li>Detect risks early in the development life cycle and address them before they are released into production.</li>
            <li>Predict whether code changes could create dangerous attack paths when combined with existing risks in the production environment.</li>
            <li>Correlate production risks back to the pre-deployment image or IaC template that was originally used to create the production instance.</li>
          </ul>
        `,
      },
      {
        image: g_feature5,
        title: "Simplify compliance reporting",
        description: `
          <p class="text-justify">Siberwander Orca generates comprehensive reports to allow teams to easily understand and communicate which controls need to be addressed to improve compliance posture and report on their progress.</p>
          <ul class="text-justify">
            <li>Report on compliance status to both internal stakeholders and auditors—with extensive customization capabilities.</li>
            <li>Share executive summaries to provide evidence of compliance progress and trends over time.</li>
            <li>Generate ad hoc or scheduled reports in CSV, JSON, and PDF formats and automatically share through email, Slack and other channels.</li>
          </ul>
        `,
      },
    ],
    faqs: []
  },
  {
    url: 'vulnerability-management',
    title: 'Cloud Vulnerability Management',
    desc: 'Detect and fix vulnerabilities in your cloud with unified context',
    challenge: 'Traditional Approaches Lack Modern Context',
    challenge_desc: 'Agent-focused solutions and vulnerability assessment scanners require tedious deployments and management for each workload, leading to high TCO. Vendors offering a choice between agents and agentless approaches only add to the complexity and often have hidden limits on their ‘agentless’ capabilities. In addition, traditional vulnerability assessment solutions lack unified context between cloud workloads and risks in the cloud control plane, such as misconfigurations and overly permissive identities.',
    partner_info: [
      {
        title: 'Enhanced Cloud Visibility',
        description: 'Traditional solutions lack context, without insights into cloud configurations and identities, leaving important security gaps.'
      },
      {
        title: 'Streamlined Deployment',
        description: 'IT teams need to spend countless hours installing, configuring, and maintaining software and partial deployment of agents and scanners causes serious blind spots.'
      },
      {
        title: 'Collaborative Security',
        description: 'Security teams often need to burden development and DevOps teams to install agents, creating organizational friction.'
      },  
    ],
    features: [
      {
        image: h_feature1,
        title: "Cloud native vulnerability management",
        description: `
          <p class="text-justify">Cloud native vulnerability management</p>
          <ul class="text-justify">
            <li>Siberwander Orca’s workload inventory includes information on OS packages, applications, libraries, as well as versions and other identifying characteristics.</li>
            <li>Unlike other solutions that simply report on the CVSS score, Siberwander Orca considers the context of cloud assets, their connections and risks, to understand which vulnerabilities need to be addressed first.</li>
            <li>In rapid response situations such as Log4Shell, Siberwander Orca allows you to quickly identify vulnerable cloud assets and prioritize patching the ones that pose the greatest risk to the business.</li>
            <li>With Siberwander Orca, you can easily query your entire environment using our modern query builder to understand vulnerabilities, risk level, and context.</li>
          </ul>
        `,
      },
      {
        image: h_feature2,
        title: "Think about vulnerabilities in terms of interconnected risks",
        description: `
          <p class="text-justify">Siberwander Orca uses Attack Path Analysis to identify dangerous risk combinations that potentially expose the company’s most valuable assets and utilizes an advanced algorithm to assign business impact scores to each path.</p>
          <ul class="text-justify">
            <li>By scoring and prioritizing attack paths, security teams can focus on a much smaller number of dangerous attack paths versus sifting through hundreds of siloed alerts.</li>
            <li>Each attack path is presented in a visual graph with contextual data on the relevant cloud entities (IAM, compute, storage, etc.) and the relations between them.</li>
            <li>For each attack path, Siberwander Orca shows which risks need to be remediated to break the attack path, further prioritizing issues for remediation if they break multiple paths.</li>
          </ul>
        `,
      },
      {
        image: h_feature3,
        title: "Easily understand how a new CVE impacts your entire environment",
        description: `
          <p class="text-justify">Because Siberwander Orca has a complete view of all your assets, workloads, identities, data and more, you can easily locate a new CVE and its impact on your environment.</p>
          <ul class="text-justify">
            <li>With the From the News widget, Siberwander Orca’s Research Pod curates breaking and trending CVEs with instant analysis of their presence and impact on your environment.</li>
            <li>Easily query your environment to surface CVE details, as well as interconnected context that adds to risk like Internet exposure or configuration status.</li>
            <li>See how vulnerabilities coordinate with other toxic risks using our Attack Path Analysis dashboard.</li>
          </ul>
        `,
      },
    ],
    faqs: []
  },
  {
    url: 'api-security',
    title: 'API Security',
    desc: 'Instant API security to inventory APIs, understand exposure, and achieve compliance',
    challenge: 'Incomplete Visibility',
    challenge_desc: 'Monitoring APIs and related security risks across multi-cloud environments requires comprehensive visibility and continuous API discovery, but existing solutions dedicated to the protection of web traffic and APIs typically require agent-based or network-based controls to get deep visibility. The result is high maintenance costs, incomplete coverage, limited API inventory, scalability challenges and lack of wider cloud security context.',
    partner_info: [
      {
        title: 'Enhanced Cloud Visibility',
        description: 'Traditional solutions lack context, without insights into cloud configurations and identities, leaving important security gaps.'
      },
      {
        title: 'Streamlined Deployment',
        description: 'IT teams need to spend countless hours installing, configuring, and maintaining software and partial deployment of agents and scanners causes serious blind spots.'
      },
      {
        title: 'Collaborative Security',
        description: 'Security teams often need to burden development and DevOps teams to install agents, creating organizational friction.'
      },  
    ],
    features: [
      {
        image: i_feature1,
        title: "Continuous API discovery and inventory",
        description: `
          <p class="text-justify">Siberwander Orca’s API dashboard provides cloud and application security teams with an overview of all high-level API data and alerts. Siberwander Orca’s API discovery is automatic and continuous and provides complete visibility into all the APIs deployed in your cloud.</p>
          <ul class="text-justify">
            <li>Track and analyze your managed and unmanaged API assets, including applications, domains, subdomains, path groups, users, and API endpoints.</li>
            <li>Get a real-world picture of publicly exposed APIs with screenshots for quick in-app view.</li>
            <li>Get answers to questions such as: “What assets are accessible from the Internet, and what do they expose? Or “How many API endpoints contain access to personally identifiable information (PII)?”</li>
          </ul>
        `,
      },
      {
        image: i_feature2,
        title: "API security risk prioritization and compliance",
        description: `
          <p class="text-justify">Siberwander Orca scans your entire cloud estate and surfaces potentially hazardous API security risks—including alerts from the OWASP API Security Top 10—providing actionable data and remediation suggestions.</p>
          <ul class="text-justify">
            <li>Prioritize risks and accelerate mitigation actions with severity scores and valuable context-based data such as the location of PII, API public exposure, and more.</li>
            <li>Take preventive steps to reduce the API attack surface. Search for the risks associated with a particular domain or subdomain, or alerts over a particular time period.</li>
            <li>Stay ahead of audits and adhere to common compliance frameworks like PCI-DSS with linked-alerts provided by Siberwander Orca.</li>
          </ul>
        `,
      },
      {
        image: i_feature3,
        title: "API security drift detection and management",
        description: `
          <p class="text-justify">Siberwander Orca ensures that potentially risky API changes and behaviors aren’t missed by security and governance teams.</p>
          <ul class="text-justify">
            <li>Continuously monitor API behavior and usage and alert teams to potentially unwanted API drift.</li>
            <li>Easily track newly added and removed applications, domains, subdomains, API paths, and API operations on those paths.</li>
            <li>Access a Swagger documentation view that can be used to easily compare intended API policy vs. current usage.</li>
          </ul>
        `,
      },
    ],
    faqs: []
  },
  {
    url: 'cloud-detection-and-response',
    title: 'Cloud Detection and Response',
    desc: 'Monitor for suspicious cloud activity to enable swift responses to active threats',
    challenge: 'Incomplete Insights Provide Incomplete Security',
    challenge_desc: 'Existing threat detection solutions were not built for the cloud and rely on agents to obtain workload telemetry. They lack insight into the entire cloud attack surface that encompasses workloads, cloud configurations, events, and identities.',
    partner_info: [
      {
        title: 'Cloud-Wide Detection Coverage',
        description: 'EDR, TDR, and XDR solutions only detect risks at the cloud workload level, not the control plane.'
      },
      {
        title: 'Comprehensive Cloud Detection',
        description: 'Many existing CDR tools are adapted from on-premises TDR, EDR, or XDR solutions that don’t offer any cloud telemetry due to lack of contextual insight.'
      },
      {
        title: 'Agent-Based Detection Challenges',
        description: 'Detection & Response tools require security agents to be installed for each asset.'
      },
    ],
    features: [
      {
        image: j_feature1,
        title: "Continuous analysis without requiring agents",
        description: `
          <p class="text-justify">Siberwander Orca’s SideScanning™ technology collects workload-deep intelligence and cloud configuration metadata without the blind spots, organizational friction, high TCO and performance hits of agent-based solutions.</p>
          <ul class="text-justify">
            <li>Automatically cover 100% of your assets, including newly added assets.</li>
            <li>Siberwander Orca combines cloud events and threat intelligence with risks found in cloud workloads, configurations and identities to understand when anomalies could potentially be dangerous.</li>
            <li>For malware-based threats, the Siberwander Orca Platform augments its CDR capabilities with signature and heuristic-based malware detection for all workloads.</li>
          </ul>
        `,
      },
      {
        image: j_feature2,
        title: "Empowering the SOC and IR team",
        description: `
          <p class="text-justify">With CDR in place, teams can leverage vital telemetry to closely monitor their cloud estate and quickly respond to suspicious activities, events, or changes demanding immediate action.</p>
          <ul class="text-justify">
            <li>With CDR in place, teams can leverage vital telemetry to closely monitor their cloud estate and quickly respond to suspicious activities, events, or changes demanding immediate action.</li>
            <li>Leverage cloud-agnostic event parameters that use universal terminology, enabling lean teams to streamline investigations without cloud-provider specialization or knowledge.</li>
            <li>Dynamically search and filter all cloud logs from a single, unified location using any event parameter, SQL query, or pre-built investigation from Siberwander Orca’s catalog.</li>
          </ul>
        `,
      },
      {
        image: j_feature3,
        title: "Fast remediation to stop attacks",
        description: `
          <p class="text-justify">Siberwander Orca helps teams quickly discover and mitigate risks, limiting any potential damage of an ongoing attack.</p>
          <ul class="text-justify">
            <li>Automate investigation and response with Siberwander Orca’s prioritized alerts, which cover all CDR use cases, fully contextualize forensic findings, and provide flexible remediation options.</li>
            <li>Accelerate response with automated workflows that resolve specific risks as soon as they are detected without requiring any manual intervention.</li>
            <li>Leverage Siberwander Orca’s AI-powered remediation feature to generate high-quality remediation instructions for each alert.</li>
          </ul>
        `,
      },
      {
        image: j_feature4,
        title: "Frictionless workflow integration",
        description: `
          <p class="text-justify">Siberwander Orca offers 50+ third-party integrations to fit seamlessly into your existing tools and workflows:</p>
          <ul class="text-justify">
            <li>Integrate CDR alerts from AWS GuardDuty, Azure Defender for Cloud, and GCP Security Command Center with Siberwander Orca for comprehensive detection.</li>
            <li>Create and monitor Jira or ServiceNow tickets directly from Siberwander Orca alerts, enhancing cross-functional collaboration.</li>
            <li>Integrate Siberwander Orca alerts with SIEM solutions (e.g. Splunk, Sumo Logic, IBM QRadar) for fast investigation and remediation.</li>
          </ul>
        `,
      },
      {
        image: j_feature5,
        title: "Gain integrated runtime visibility and security for critical workloads",
        description: `
          <p class="text-justify">Integrated with the Siberwander Orca Platform, Siberwander Orca Sensor enables you gain powerful runtime visibility, detection, investigation, and prevention for your critical workloads.</p>
          <ul class="text-justify">
            <li>Leverage rich telemetry that deepens the visibility of the Siberwander Orca Platform with a real-time view of activity, active threats, malicious and suspicious behavior flows, and more.</li>
            <li>Use our extensive library of built-in detections to detect and prevent a wide range of threats, including memory persistence and execution even for fileless attacks.</li>
            <li>Take advantage of runtime protection optimized for cloud-native applications with a flexible, lightweight solution built for the future of preventive and proactive security.</li>
          </ul>
        `,
      },
    ],
    faqs: [
      {
        question: "What is CDR?",
        answer: `
        <p>Cloud Detection and Response (CDR) is a branch of cloud security that focuses on detecting active attacks in cloud environments and provides organizations with the information and tools needed for security teams to investigate and respond to these attacks.</p>
        <br/>
        <p>The main objective of CDR is to detect cloud attackers who have breached the perimeter controls of cloud resources and applications. By continuously providing security operation center (SOC) and incident response (IR) teams with contextualized data on potential malicious activity in the cloud environment, CDR accelerates investigation and response to cloud attacks.</p>
        `
      },
      {
        question: "Why is CDR important?",
        answer: `
        <p>As organizations increasingly depend on the cloud, many still rely on traditional, on-premises tools to detect and respond to cloud attacks, providing limited insight, missed attacks, and high rates of false positives. CDR helps organizations gain the visibility and awareness of in-progress cloud attacks, accelerate and enhance their response, and limit the scope and severity of incidents.</p>
        `
      },
      {
        question: "How does CDR work?",
        answer: `
        <p>As with on-premises detection and response, CDR involves four stages:</p>
        <ul>
          <li><b>Detection:</b> Continuous or frequent monitoring for attacks across cloud services feeds with alerting capabilities.</li>
          <li><b>Investigation:</b> Review of attack steps, techniques, and timelines, and analysis of available data to determine a needed response to the threat.</li>
          <li><b>Response:</b> Capabilities that focus on ensuring cloud threats are contained before they can do damage, such as auto-remediation or automatic forwarding to ticketing systems.</li>
          <li><b>Resilience:</b> Organizations conduct a post-mortem investigation, draw conclusions, and focus on potential remediations based on available data. Following threat mitigation, they investigate the root cause, and take actions—patching, encryption, stricter IAM policies—that harden the cloud environment.</li>
        </ul>
        `
      },
      {
        question: "What are the alternative solutions to CDR?",
        answer: `
        <p>Alternative solutions to CDR include:</p>
        <ul>
          <li><b>Endpoint Detection and Response (EDR):</b> EDR solutions treat endpoints as potential attack vectors. They use agents to record endpoint activity and identify potential threats, and rely on anomaly detection, machine learning, and other approaches.</li>
          <li><b>Network Detection and Response (NDR):</b> NDR detects threats by analyzing organizational network traffic. NDRs look for potential threats based on anomalous or unauthorized protocols, port utilization, odd timing and transfer sizes, and more.</li>
          <li><b>Threat Detection & Response (TDR):</b> TDR typically gathers information most relevant to a current threat. Endpoint TDR tools record data about an identified threat or analyze if an event or process constitutes a threat. Analytical TDRs leverage existing data and apply analytics to identify threats.</li>
          <li><b>Extended Detection & Response (XDR):</b> XDR platforms detect threats by ingesting endpoint agent data, network level information, and device logs.</li>
        </ul>
        <p>However these solutions don’t offer any actual cloud telemetry like CDR does and are siloed tools without any contextual insight into the existing cloud environment risks. Therefore these tools tend to have a higher rate of false positives since they cannot accurately assess the danger of certain actions.</p>
        `
      },
      {
        question: "How does Siberwander Orca’s enhance CDR?",
        answer: `
        <p>Siberwander Orca Security Platform provides around-the-clock monitoring of cloud provider logs and threat intelligence feeds. Siberwander Orca ingests this information and integrates it with our insights into existing risks across the cloud estate and the location of an organization’s most critical assets. This enables Siberwander Orca to quickly detect potentially dangerous events that require immediate attention.</p>
        <br/>
        <p>With Siberwander Orca’s CDR solution, you can detect, investigate, and respond to in-progress cloud attacks:</p>
        <ul>
          <li><b>Detect:</b> Get prioritized alerts about events that endanger your most critical assets.</li>
          <li><b>Investigate:</b> Gain quick insights into security events, including whether they’re malicious and if they threaten your critical assets.</li>
          <li><b>Respond:</b> Remediate in-progress cloud attacks quickly with automated remediation steps and integrations.</li>
        </ul>
        `
      }
    ]
  },
  {
    url: 'shift-left-security',
    title: 'Shift Left Security',
    desc: 'Fix vulnerabilities, secrets, and misconfigurations early in the SDLC',
    challenge: 'Development, DevOps, and Security Teams Are Operating in Silos',
    challenge_desc: 'The benefits of Shift Left Security are clear. However, putting this process into practice is more difficult. Although there are security tools that scan either IaC templates or container images, many don’t do both or lack integration across the software development lifecycle.',
    partner_info: [
      {
        title: 'Secure Development Speed',
        description: 'Developers need to identify vulnerabilities and security issues while shipping code quickly.'
      },
      {
        title: 'Simplified Tool Integration',
        description: 'DevOps teams must manage policies and create integrations for multiple tools, duplicating efforts and hindering consistency.'
      },
      {
        title: 'Context-Driven Collaboration',
        description: 'Security teams struggle with siloed solutions, lack of shared context, and contradictory alerts.'
      },  
    ],
    features: [
      {
        image: k_feature1,
        title: "Secure your IaC code",
        description: `
          <p class="text-justify">Misconfigurations in IaC code can quickly propagate by the hundreds and thousands when reused for other projects. To prevent this, Siberwander Orca offers detailed IaC scanning to catch issues early in the SDLC.</p>
          <ul class="text-justify">
            <li>Easily set and customize policies for IaC scanning – including guardrails – to reflect your unique security requirements.</li>
            <li>Validate IaC code across popular IaC platforms, including Terraform, AWS CloudFormation, Azure Resource Manager, Google Deployment Manager, Ansible, Kubernetes, and more.</li>
            <li>Automatically scan IaC code on every pull request to detect new issues or policy violations.</li>
            <li>Notify developers of any issues that need to be addressed, including their precise location and steps for remediation.</li>
          </ul>
        `,
      },
      {
        image: k_feature2,
        title: "Detect Secrets before committing code",
        description: `
          <p class="text-justify">Attackers can discover exposed secrets in minutes. Siberwander Orca prevents secrets exposure by detecting them early in the SDLC, long before code is built or shipped so you can keep secrets, secret.</p>
          <ul class="text-justify">
            <li>Integrate secrets detection into development platforms for automatic scanning, dynamic alert scoring, and risk prioritization using Siberwander Orca’s GitHub App, GitLab App, or Siberwander Orca CLI.</li>
            <li>Easily customize policies for secret detection to filter for specific security issues and set guardrails for blocking builds or notifying developers.</li>
            <li>Leverage Siberwander Orca’s pre-commit hook to detect issues before they reach repositories, eliminating the need for secret rotations, risk analysis, and other post-commit measures.</li>
          </ul>
        `,
      },
      {
        image: k_feature3,
        title: "Software Composition Analysis (SCA) to detect open-source risks",
        description: `
          <p class="text-justify">Open-source vulnerabilities, misconfigurations, and licensing requirements are a question of “when,” not “if.” With Siberwander Orca you can automatically detect and secure open-source software in your codebase for enhanced security and confidence.</p>
          <ul class="text-justify">
            <li>Automatically scan container images, filesystems, and Git repositories on every push or pull request.</li>
            <li>Obtain a full SBOM of your Code repositories, including transitive dependencies.</li>
            <li>Identify vulnerabilities introduced by dependencies across a wide range of packages, including Ruby, Python, PHP, Node.js, .NET, Java, Golang, and more.</li>
          </ul>
        `,
      },
      {
        image: k_feature4,
        title: "Keep Source Code Management configurations secure",
        description: `
          <p class="text-justify">Source Code Management (SCM) platforms can present significant security risks if not properly configured. With Siberwander Orca, security teams can go beyond code security to detect and remediate misconfigurations and risks across SCM accounts and repositories.</p>
          <ul class="text-justify">
            <li>Get a comprehensive and detailed inventory of your repository instances, including any new repositories when they are created.</li>
            <li>Scan SCM platforms and assets using industry best practices from the Open Source Security Foundation (OPSSF), Legitify, and other industry standards.</li>
            <li>Leverage Siberwander Orca’s dynamic risk assessments and prioritized alerts to enhance remediation efforts, reduce alert fatigue, and maximize productivity.</li>
          </ul>
        `,
      },
      {
        image: k_feature5,
        title: "Build security into every CI/CD process",
        description: `
          <p class="text-justify">Embed comprehensive cloud security checks into your CI/CD process by leveraging the easy-to-use Siberwander Orca command-line interface (Orca CLI) and native integrations to:</p>
          <ul class="text-justify">
            <li>Automatically run all the critical security and compliance checks using CIS benchmarks and custom policies.</li>
            <li>Surface findings in native development tooling as well as the Siberwander Orca Platform UI.</li>
            <li>Siberwander Orca supports common CI and development tools, including Jenkins, BitBucket, CircleCI, GitHub, GitLab, and more.</li>
          </ul>
        `,
      },
      {
        image: k_feature6,
        title: "Frictionless workflow integration and automation",
        description: `
          <p class="text-justify">Siberwander Orca offers a number of off the shelf integrations so you can fit Siberwander Orca into your existing workflows, ensuring fast remediation and avoiding confusion about team responsibilities.</p>
          <ul class="text-justify">
            <li>Forward findings to notification systems such as email, PagerDuty, OpsGenie, and Slack.</li>
            <li>Auto assign alerts to remediation teams with ticketing systems such as Jira or ServiceNow.</li>
            <li>Apply security policy directly in GitHub using the native Siberwander Orca GitHub app</li>
            <li>Automate remediation by integrating Siberwander Orca with SOAR systems, including Torq and Brinqa</li>
          </ul>
        `,
      },
    ],
    faqs: []
  },
  {
    url: 'ai-security-posture-management',
    title: 'AI Security Posture Management (AI-SPM)',
    desc: 'Get full visibility into deployed AI models and protect against data tampering and leakage.',
    challenge: 'AI Deployments Rapidly Introduce Cloud Security Risks',
    challenge_desc: 'AI presents a myriad of business benefits. Yet without the right AI security in place, organizations face new cloud risks, some familiar, and some unique to AI models. Siloed AI-SPM products only multiply the existing challenges facing security teams—alert fatigue, blind spots, and inability to see the bigger picture—while leaving organizations exposed to critical risks.',
    partner_info: [
      {
        title: 'Discover Shadow AI',
        description: 'Security teams don’t know which AI models are in use and aren’t able to discover shadow AI.'
      },
      {
        title: 'Prevent Model Exposure',
        description: 'Misconfigured public access settings, exposed keys, and unencrypted data can cause model theft.'
      },
      {
        title: 'Protect Sensitive Data',
        description: 'If sensitive data is (accidentally) included in training data, this can cause AI models to expose sensitive data and PII.'
      },
    ],
    features: [
      {
        image: l_feature1,
        title: "Get full visibility into your deployed AI projects",
        description: `
          <p class="text-justify">Much like other resources in the cloud, shadow AI and LLMs are a major security concern. Siberwander Orca continuously scans your entire cloud environment and detects all deployed AI models, keeping security teams in the know about every AI project, whether it contains sensitive data, and whether it’s secure.</p>
          <ul class="text-justify">
            <li>Get a complete AI inventory and BOM for every AI model deployed in your cloud, giving you visibility into any shadow AI.</li>
            <li>Siberwander Orca covers the major cloud provider AI services, such as Azure OpenAI, Amazon Bedrock & Sagemaker, and Google Vertex AI.</li>
            <li>Siberwander Orca also inventories the 50+ most commonly used AI software packages, including Pytorch, TensorFlow, OpenAI, Hugging Face, scikit-learn, and many more.</li>
          </ul>
        `,
      },
      {
        image: l_feature2,
        title: "Leverage AI Posture Management (AI-SPM)",
        description: `
          <p class="text-justify">Siberwander Orca’s AISPM alerts when AI models are at risk from misconfigurations, overprivileged permissions, Internet exposure, and more, and provides automated and guided remediation to quickly fix any issues.</p>
          <ul class="text-justify">
            <li>Siberwander Orca’s compliance framework for AI best practices includes dozens of rules for proper upkeep of AI models, network security, data protection, access controls, IAM, and more.</li>
            <li>Protect against data leakage and data poisoning risk from AI models and training data.</li>
          </ul>
        `,
      },
      {
        image: l_feature3,
        title: "Detect sensitive data in AI models and training data",
        description: `
          <p class="text-justify">Siberwander Orca uses Data Security Posture Management (DSPM) capabilities to scan and classify the data stored in AI projects, and alerts if any sensitive data is found. By informing security teams where sensitive data is located, they can make sure that it is removed since AI models can be manipulated into “pouring” their training data.</p>
          <ul class="text-justify">
            <li>Siberwander Orca scans and classifies all the data stored in AI projects, as well as data used to train or fine-tune AI models.</li>
            <li>Receive an alert when sensitive data is found, such as telephone numbers, email addresses, social security numbers, or personal health information.</li>
            <li>Ensure that your AI models are fully compliant with regulatory frameworks and CIS benchmarks.</li>
          </ul>
        `,
      },
      {
        image: l_feature4,
        title: "Detect exposed AI access keys to prevent tampering",
        description: `
          <p class="text-justify">Siberwander Orca detects when AI keys and tokens are left in code repositories, and sends out alerts so security teams can swiftly remove the keys and limit any damage.</p>
          <ul class="text-justify">
            <li>Siberwander Orca scans your code repositories (such as GitHub and GitLab), finding any leakage of AI access keys – such as tokens to OpenAI, Hugging Face.</li>
            <li>Leaked access keys could grant bad actors access to AI models and their training data, allowing them to make API requests, tamper with the AI model, and exfiltrate data.</li>
          </ul>
        `,
      },
    ],
    faqs: [
      {
        question: "What is AI-SPM?",
        answer: `
        <p>AI Security Posture Management is an emerging field of cloud security that involves addressing security risks and compliance issues associated with using AI models. It involves a collection of strategies, solutions, and practices designed to enable organizations to securely leverage AI models and LLMs in their business.</p>
        <br/>
        <p>Like other cloud assets, AI models and LLMs present inherent security risks, including limited visibility, accidental public access, shadow data, unencrypted data, unsecured keys, and more.</p>
        `
      },
      {
        question: "Why is AI-SPM important?",
        answer: `
        <p>In recent years, AI usage has increased dramatically. More than half of all organizations already use it in the course of their business. AI’s widespread adoption, coupled with the security risks of using AI services and packages, puts organizations at heightened risk of security incidents. The below figures help illustrate this risk:</p>
        <ul>
          <li>94% of organizations using OpenAI have at least one account that is publicly accessible without restrictions.</li>
          <li>97% of organizations using Amazon Sagemaker notebooks have at least one with direct internet access.</li>
        </ul>
        `
      },
      {
        question: "What are the risks of AI?",
        answer: `
        <p>Despite its advantages, AI poses significant security risks that organizations must consider and address, including:</p>
        <ul>
          <li><b>Lack of visibility:</b> Security teams don’t always know which AI models are currently in use and aren’t able to discover shadow AI.</li>
          <li><b>Data exposure:</b> Misconfigured public access settings, exposed keys, and unencrypted sensitive data can cause data leakage.</li>
          <li><b>Data poisoning:</b> Bad actors can potentially tamper with data and insert malicious content.</li>
          <li><b>Key exposure in repositories:</b> These keys allow bad actors to make API requests, tamper with the AI model, and exfiltrate data.</li>
        </ul>
        `
      },
      {
        question: "How Does AI-SPM Work?",
        answer: `
        <p>AI Security Posture Management involves several important activities to cover end-to-end AI risks, including:</p>
        <ul>
          <li><b>Cloud scanning and inventorying:</b> The entire cloud estate is scanned to generate a full inventory of all AI models deployed within the cloud environment(s).</li>
          <li><b>Security posture management:</b> Secure configuration of AI models is ensured, including network security, data protection, access controls, and IAM.</li>
          <li><b>Sensitive data detection:</b> Sensitive information in AI models or training data is identified and alerts are generated so appropriate action can be taken.</li>
          <li><b>Third-party access detection:</b> Teams are alerted when sensitive keys and tokens to AI services are exposed in code repositories.</li>
        </ul>
        `
      },
      {
        question: "What are the advantages of Siberwander Orca's AI-SPM?",
        answer: `
        <p>The Siberwander Orca Cloud Security Platform secures your AI models from end-to-end—from training and fine-tuning, to production deployment and inference.</p>
        <ul>
          <li><b>AI and ML Inventory and BOM:</b> The entire cloud estate is scanned to generate a full inventory of all AI models deployed within the cloud environment(s).</li>
          <li><b>Security posture management:</b> Ensure that AI models are configured securely, including network security, data protection, access controls, and IAM.</li>
          <li><b>Sensitive data detection:</b> Be alerted if any AI models or training data contain sensitive information so you can take appropriate action.</li>
          <li><b>Third-party access detection:</b> Detect when keys and tokens to AI services— such as OpenAI, Hugging Face—are unsafely exposed in code repositories.</li>
        </ul>
        `
      }
    ]
  },
  {
    url: 'ai-driven-cloud-security',
    title: 'AI-Driven Cloud Security',
    desc: 'Simplify investigations and accelerate remediation with built-in generative AI',
    challenge: 'Overwhelmed Cloud Security Teams',
    challenge_desc: 'Cloud security teams are receiving hundreds of alerts each day that require investigation, remediation and response. As cloud environments increase in complexity, more advanced technical skills are needed, further adding to the cloud security skills gap. Many cloud security tools are difficult to operationalize and use, resulting in limited value to the organization and leaving teams struggling to understand their cloud environments.',
    partner_info: [
      {
        title: 'Empowered Security Teams',
        description: 'Short-staffed cloud security teams struggle to keep up, resulting in burnout and turnover.'
      },
      {
        title: 'Accessible Security Tools',
        description: 'Cloud security tools that require specialized skills and training bring limited value.'
      },
      {
        title: 'Simplified Cloud Management',
        description: 'Cloud environments are becoming more complex, requiring more advanced technical knowledge.'
      },
      {
        title: 'Critical Alert Handling',
        description: 'Cloud security falls behind, with critical alerts being missed.'
      },  
    ],
    features: [
      {
        image: m_feature1,
        title: "AI-generated, ready-to-use remediation steps",
        description: `
          <p class="text-justify">Instantly generate high-quality remediation instructions for each alert straight from the Siberwander Orca Platform, enabling your team to address cloud vulnerabilities and risks 2-3 times faster. Data privacy is ensured by anonymizing requests and masking any sensitive data.</p>
          <ul class="text-justify">
            <li>Copy and paste remediation code into a command line interface or Infrastructure as Code (IaC) provisioning tools, or follow steps in the console.</li>
            <li>Ask follow-up questions to fine-tune remediation steps if needed.</li>
            <li>Leverage Azure OpenAI, Google Vertex AI, or Amazon Bedrock as your AI engine.</li>
          </ul>
        `,
      },
      {
        image: m_feature2,
        title: "AI-powered search as intuitive as asking a question",
        description: `
          <p class="text-justify">Siberwander Orca greatly simplifies searches by enabling users to ask natural language questions such as ‘Do I have any log4j vulnerabilities that are public facing?’ or “Do I have any unencrypted databases with sensitive data exposed to the Internet?”. This intuitive approach significantly reduces time-to-discovery, reducing risk and improving compliance.</p>
          <ul class="text-justify">
            <li>Users across the organization, regardless of their skill level, can easily understand exactly what’s in their cloud environment.</li>
            <li>Advanced users can craft complex and granular queries much faster than any human can.</li>
            <li>If applicable, Siberwander Orca suggests related query options that could be used to refine results further.</li>
          </ul>
        `,
      },
      {
        image: m_feature3,
        title: "IAM policy management powered by AI",
        description: `
          <p class="text-justify">Siberwander Orca leverages AI to simplify the complex task of securing identities and permissions and almost instantly helps organizations optimize their IAM policies to comply with the principle of least privilege and other best practices.</p>
          <ul class="text-justify">
            <li>Siberwander Orca compares existing IAM policies to actual policy usage to recommend the optimal policy configurations that provide the largest security improvements with the least amount of changes.</li>
            <li>Get detailed information on suggested policy changes so you can select the best policy configuration for your needs.</li>
            <li>The selected configuration can be downloaded and effortlessly applied to your cloud account.</li>
          </ul>
        `,
      },
      {
        image: m_feature4,
        title: "AI-generated alert and asset descriptions",
        description: `
          <p class="text-justify">Siberwander Orca’s dynamic alert and asset descriptions greatly simplify investigations, summarizing all the important information that teams need to know in an easily consumable manner, reducing investigation time and improving Mean Time To Remediation (MTTR).</p>
          <ul class="text-justify">
            <li>For assets, Siberwander Orca summarizes which risks are found and of what severity, how many attack paths they are part of, whether the asset is Internet-facing, running or paused, and more.</li>
            <li>For alerts, Siberwander Orca explains what the risk is, when it was first found, if it is exploitable, whether there’s a fix, how an attacker could abuse it, and more.</li>
            <li>Where applicable, descriptions contain links to other resources with more information</li>
          </ul>
        `,
      },
      {
        image: m_feature5,
        title: "Intelligent anomaly detection using AI",
        description: `
          <p class="text-justify">Siberwander Orca uses advanced analytics and machine learning algorithms to rapidly analyze and detect anomalies in cloud feeds, workloads, and configurations that might indicate malicious activity. By empowering teams to act swiftly on accurate and actionable alerts, the potential damage of a breach is greatly reduced.</p>
          <ul class="text-justify">
            <li>Siberwander Orca performs continuous behavioral analysis to detect differences from baseline behavior.</li>
            <li>Leveraging full contextual insights into the cloud environment, Siberwander Orca minimizes false positives and avoids alert fatigue.</li>
            <li>Siberwander Orca enables teams to respond quickly and effectively by simplifying investigations and visually displaying potential attack paths.</li>
          </ul>
        `,
      },
    ],
    faqs: []
  },
  {
    url: 'agentless-sidescanning',
    title: 'Agentless Cloud Security',
    desc: 'Cloud security that deploys in minutes and offers deep and wide risk visibility',
    challenge: 'Agent-Based Solutions Don’t Work in the Cloud',
    challenge_desc: 'Agents require tedious integration with each workload, causing dangerous blind spots, high TCO, performance degradation, and limiting the ability of your already overworked IT and DevOps teams to move at cloud speed. Vendors that offer an ‘agentless’ option in addition to their agent-based solution, often have hidden limitations and increase complexity even more.',
    partner_info: [
      {
        title: 'Eliminate Blind Spots',
        description: 'Partial deployment of agents causes serious blind spots. On average, we found that less than 50% of assets are covered by agent-based solutions.'
      },
      {
        title: 'Agent-Free Cloud Security',
        description: 'Before risks can be detected, agent-based solutions require installation on each workload, which is simply not feasible given the ephemeral nature of the cloud.'
      },
      {
        title: 'DevOps Integration',
        description: 'If security does not integrate effortlessly with DevOps workflows, priority mismatches and confusion about team responsibilities will lead to frustration and remediation delays.'
      },
      {
        title: 'Optimize Performance',
        description: 'Running agents on workloads has a significant impact on asset performance and system resources, especially if assets need multiple agents installed for different point solutions.'
      },
    ],
    features: [
      {
        image: n_feature1,
        title: "An ‘MRI’ for your cloud estate",
        description: `
          <p class="text-justify">SideScanning is a bit like a medical MRI scanner – instead of using needles and scalpels, the MRI machine diagnoses health issues through non-invasive scanning of organs and tissue. SideScanning is similar in that it scans all cloud assets and their interconnectivity, providing deep and wide visibility into the entire cloud estate, without affecting the assets in any way.</p>
        `,
      },
      {
        image: n_feature2,
        title: "Capturing workload telemetry no other solution can",
        description: `
          <p class="text-justify">SideScanning covers all major workload types, including Linux and Windows VMs, containers and container images, and serverless functions. While most solutions only identify basic vulnerabilities, Orca provides detailed data on compliance issues, log inspection, file integrity monitoring, malware analysis, and more to offer telemetry that other solutions lack.</p>
        `,
      },
    ],
    faqs: []
  },
]

export default solution_data